import React, { useEffect, useState } from 'react';
import { SnackbarContext } from '../../context/SnanckarContext';
import { SnackbarState } from '../../types/snackbar-context.type';
import { useRouter } from 'next/router';
import { RoutesEnum } from '../../types/routes.enum';

interface Props {
    children: React.ReactNode;
}

const SnackbarProvider = ({ children }: Props) => {
    const [snackbarContext, setSnackbarContext] = useState<SnackbarState>({
        open: false,
    });
    const contextValue = { snackbarContext, setSnackbarContext };
    const router = useRouter();

    useEffect(() => {
        if (
            typeof router.query['info'] === 'string' &&
            !router.pathname.includes(RoutesEnum.LOGOUT)
        ) {
            setSnackbarContext({
                open: true,
                message: router.query['info'],
            });
        }
    }, [router, setSnackbarContext]);

    return (
        <SnackbarContext.Provider value={contextValue}>
            {children}
        </SnackbarContext.Provider>
    );
};

export default SnackbarProvider;
